export default "__VITE_ASSET__24fb8c6b__"